module.exports = __webpack_public_path__ + "media/conmex/novedades-306706e6.png";